import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { ReportDefinition, TargetEntityType } from "./reportMetaData";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { Config } from "../core/config/config";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Entity } from "../core/components/commonApp";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class CrTemplateQRAGrid extends React.Component<CrTemplateQRAGridProps, CrTemplateQRAGridState> {
    private gridOptions: kendo.ui.GridOptions;
    private translations: StringKeyDictionary<string>;
    private newTags: string[] = []
    private sheet: Sheet;
    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            selectedItem: null
        }
        this.initApp();
    }

    private initApp = async () => {
        this.loadData();
        this.sheet = General.Sheet.Manager.getTopMostVisibleSheet();
        const result = await Helper.getTranslations(["Standard.Key", "Standard.Name", "Field.Adresse.iaktiv", "WebSMS.ReportMetadata.TargetEntityType", "Standard.Öffnen"]);
        this.translations = result.Data;
        this.setGridOptions();
        this.setState({});
    }

    private setGridOptions = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Name",
                    title: this.translations["Standard.Name"]
                },
                {
                    field: "IsActive",
                    title: this.translations["Field.Adresse.iaktiv"],
                    template: "# if(data.State == 1) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                }
            ]
        };
    }

    private loadData = async () => {
        const result = await HTTPService.get<JsonResultClass<GridData[]>>("ReportMetaData/GetByTemplateId?templateId=" + this.props.entity.ISGuid);
        switch (result.Code) {
            case 0:
                this.setState({ gridData: result.Data })
                break;
        }
    }

    private createGrid = () => {
        let standardButtons: Array<ToolBarStandardButton> = [];
        if (this.props.entity.RecordRight.CanWrite && this.props.entity.RecordRight.CanRead) {
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        }

        let customButtons: Array<GridCustomToolBarButton> = []
        if (this.props.entity.RecordRight.CanRead) {
            customButtons.push({ autoEnabledOnRecordSelected: true, caption: this.translations["Standard.Öffnen"], enabled: true, id: "open", iconClass: "k-i-eye" })
        }

        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="crTemplateQRA"
                    standardButtons={standardButtons}
                    onClickStandardButton={this.onStandardClick}
                    customButtons={customButtons}
                    onClickCustomButton={this.onCustomClick}
                />
            </div>
        );
    }

    private onStandardClick = (type: ToolBarStandardButtonType, dataItem: GridData) => {
        if (type === ToolBarStandardButtonType.NEW) {
            const url = `ReportMetaData/New?templateId=${this.props.entity.ISGuid}`;
            this.open(url);
        }
    }

    private onCustomClick = (id: string, dataItem: GridData) => {
        if (id === "open") {
            const url = `ReportMetaData/Edit?id=${dataItem.Id}&readOnly=${!this.props.entity.RecordRight.CanWrite}&templateId=${this.props.entity.ISGuid}`;
            this.open(url);
        }
    }

    private open = (url: string) => {
        const reportMetaDataSheet = General.Sheet.Manager.createSheetWithUrl(url);
        reportMetaDataSheet.bind(SheetEventType.Close, () => { this.loadData() })
        reportMetaDataSheet.bind(SheetEventType.Custom, (data: { cmd: string, data: any }) => {
            if (data.cmd == "tagAdded") {
                const tag: string = data.data;
                this.newTags.push(tag);
            }
        })
        reportMetaDataSheet.bind(SheetEventType.SavedSuccessfully, (data: { entity: ReportDefinition }) => {
            const tags = data.entity.TargetCriterias.Tags.filter(tag => this.newTags.indexOf(tag) > -1);
            this.sheet.trigger(SheetEventType.Custom, { cmd: "addNewTags", tags: tags });
        })
    
    }

    render() {
        return Helper.hasValue(this.translations) && Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
    }
}

interface TemplateEntity extends Entity {
    ISGuid: string;
}

interface CrTemplateQRAGridProps {
    entity: TemplateEntity;
}

interface CrTemplateQRAGridState {
    gridData: GridData[];
    selectedItem: GridData;
}

interface GridData {
    Id: number;
    Name: string;
    TargetEntityTypeName: string;
    TargetEntityType: TargetEntityType;
    IsActive: boolean;
}